import { useRef } from 'react'
import cn from 'classnames'
import { Form } from 'formik'
import { useHistory } from 'react-router'

import Modal from 'components/Modal'
import { DialogModal } from 'components/DialogModal'
import { SpySidebar } from 'components/shared/SpySidebar'

const Item = ({
  settings,
  showValidationErrors,
  setShowDeleteDialog,
  onArchive,
  modalBody,
  showDeleteDialog,
  setShowValidationErrors,
  itemIdIsNew,
  isLoading,
}) => {
  const history = useHistory()
  const itemSettingsRef = useRef()

  const onCloseModal = () =>
    history.push({ state: { itemUuid: null } })

  const submitButtonClassName = itemIdIsNew ? '-new' : '-update'
  const modalTitle = itemIdIsNew ? 'Add an Item' : 'Edit Item'

  return (
    <>
      <Modal
        title={modalTitle}
        onClose={onCloseModal}
        isLoading={isLoading}
        onRequestClose={onCloseModal}
      >
        <div className="modal-body">
          <Form>
            <div className="item-settings" ref={itemSettingsRef}>
              {settings.map(({ Component, ref, text, ...props }) => (
                <section
                  key={text}
                  className="item-settings__section"
                  ref={ref}
                  id={text}
                >
                  <Component
                    {...props}
                    key={text}
                    showValidationErrors={showValidationErrors}
                  />
                </section>
              ))}
              <DialogModal
                closeModalCallback={setShowDeleteDialog}
                confirmationCallback={onArchive}
                modalBody={modalBody}
                modalButtonText="Confirm"
                modalIsOpen={showDeleteDialog}
                modalTitle="Archive Item"
              />
            </div>
            <div className="btn-wrapper">
              <button
                className={cn('btn', submitButtonClassName)}
                type="submit"
                onClick={() => setShowValidationErrors(true)}
              >
                {itemIdIsNew ? 'Add Item' : 'Update'}
              </button>
            </div>
          </Form>
          <SpySidebar
            settings={settings}
            root={itemSettingsRef?.current}
          />
        </div>
      </Modal>
    </>
  )
}

export default Item
